const LEVEL_NAME = ['INFO', 'DEBUG']
const LEVEL_NAME_INFO = 0
const LEVEL_NAME_DEBUG = 1

let _output = (level, tag, content) => {
  // return
  if (process.env.NODE_ENV === 'production') {
    return
  }
  let text = LEVEL_NAME[level] + ' : ' + tag + ' => ' + JSON.stringify(content)
  // alert(text)

  switch (level) {
    case LEVEL_NAME_INFO:
      console.info(text)
      break
    case LEVEL_NAME_DEBUG:
      console.debug(text)
      break
    default:
      console.error('ERR level:' + level)
  }
}

export default {
  info: (tag, content) => {
    _output(LEVEL_NAME_INFO, tag, content)
  },
  debug: (tag, content) => {
    _output(LEVEL_NAME_DEBUG, tag, content)
  }
}



// WEBPACK FOOTER //
// ./src/utils/log.js